import moment from 'moment';

export const getEnhancedPayments = obj => ({
    page: obj.page,
    per_page: obj.itemsPerPage,
    filter_roles: obj?.roles,
    filter_investmentFunds: obj.product?.id ? [obj.product?.id] : obj.product,
    filter_paymentMethod: [obj.type],
    order_by: obj.orderBy,
    order_direction: obj.direction,
    enrich_with: obj.enrichments,
    filter_search: obj.keyword,
    filter_paymentStatus: obj.status,
    filter_companyId: obj.company === 'all' ? undefined : obj.company,
    filter_subscriptionFinishedFromDate: obj?.entryDateStart
        ? moment(obj.entryDateStart).toISOString()
        : null,
    filter_subscriptionFinishedToDate: obj?.entryDateEnd
        ? moment(obj.entryDateEnd).toISOString()
        : null,
    filter_investingSumMin: obj?.minSum,
    filter_investingSumMax: obj?.maxSum,
    filter_minAdmissionFee: obj?.minAdmissionFee,
    filter_maxAdmissionFee: obj?.maxAdmissionFee,
    filter_shareSubcategories: obj?.subcategory === 'all' ? undefined : [obj?.subcategory],
    filter_investorClassification:
        obj.investorClassification === 'all' ? undefined : obj.investorClassification,
    filter_subscriptionCreatedBy:
        obj.subscriptionCreatedBy === 'all' ? undefined : [obj.subscriptionCreatedBy],
    filter_subscriptionCreatedByTag: obj?.tag,
    filter_subscriptionId: obj?.subscriptionId,
});

export const addPartialPayment = ({ payment, amount }) => ({
    amount: +amount,
    id: payment.id,
});
